import React from 'react'

export const IconFacebookLogin = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g fill="none">
      <path
        d="M16 8C16 3.6 12.4 0 8 0 3.6 0 0 3.6 0 8 0 12 2.9 15.3 6.8 15.9L6.8 10.3 4.7 10.3 4.7 8 6.8 8 6.8 6.2C6.8 4.2 7.9 3.1 9.8 3.1 10.6 3.1 11.6 3.3 11.6 3.3L11.6 5.3 10.6 5.3C9.6 5.3 9.3 5.9 9.3 6.5L9.3 8 11.5 8 11.1 10.3 9.3 10.3 9.3 15.9C13.1 15.3 16 12 16 8"
        fill="#1877F2"
      ></path>
      <path
        d="M11.1 10.3L11.5 8 9.3 8 9.3 6.5C9.3 5.9 9.6 5.3 10.6 5.3L11.6 5.3 11.6 3.3C11.6 3.3 10.6 3.1 9.8 3.1 7.9 3.1 6.8 4.2 6.8 6.2L6.8 8 4.7 8 4.7 10.3 6.8 10.3 6.8 15.9C7.2 16 7.6 16 8 16 8.4 16 8.8 16 9.3 15.9L9.3 10.3 11.1 10.3"
        fill="#FFF"
      ></path>
    </g>
  </svg>
)
